import { IArrival } from '@/coreDomainsModule/entities/arrival';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BulkPutOrderRequest, BulkPutOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { bulkPutUnpaidOrderedOrderArapter } from '../adapters/bulkPutUnpaidOrderedOrderAdapter';

/**
 * 発注済み未納の納期とステータスを変更するUseCase
 */
export class bulkPutUnpaidOrderedOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注済み未納の納期とステータスを変更する
   * @param updateOrderInfo - 編集したい発注情報
   * @returns - 編集に成功した発注IDと、失敗した発注IDをまとめたobj
   */
  public async execute(updateOrderInfo: IArrival[]): Promise<INetworkResult<BulkPutOrderResponseResult, Error>> {
    const request: BulkPutOrderRequest = {
      bulkPutOrderInfo: updateOrderInfo.map((order) => bulkPutUnpaidOrderedOrderArapter.adapt(order)),
      abortOnInvalid: false,
    };
    try {
      const result = await this.repository.bulkPut(request);
      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
